import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { ExperienceEditorPage } from "@/lib/features/ExperienceEditorPage";
import { trpc } from "@/router";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_app/upptack/redigera/$slug")({
  component: EditExperiencePage
});
function EditExperiencePage() {
  const $ = _c(3);
  const {
    slug
  } = Route.useParams();
  if (slug === "ny") {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = /*#__PURE__*/_jsx(ExperienceEditorPage, {});
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== slug) {
    t0 = /*#__PURE__*/_jsx(EditExisting, {
      slug: slug
    });
    $[1] = slug;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function EditExisting(t0) {
  const $ = _c(11);
  const {
    slug
  } = t0;
  let t1;
  if ($[0] !== slug) {
    t1 = trpc.experiences.bySlug.queryOptions({
      slug
    });
    $[0] = slug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: experience,
    isLoading
  } = useQuery(t1);
  if (isLoading) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /*#__PURE__*/_jsx("div", {
        className: "flex min-h-[60vh] items-center justify-center",
        children: /*#__PURE__*/_jsx("div", {
          className: "h-8 w-8 animate-spin rounded-full border-4 border-brand/30 border-t-brand"
        })
      });
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (!experience) {
    throw notFound();
  }
  const t2 = experience.titleSlug ?? "";
  const t3 = experience.subtitle ?? "";
  const t4 = experience.description ?? "";
  let t5;
  if ($[3] !== experience.id || $[4] !== experience.isPublished || $[5] !== experience.placeId || $[6] !== experience.title || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = /*#__PURE__*/_jsx(ExperienceEditorPage, {
      experience: {
        id: experience.id,
        title: experience.title,
        titleSlug: t2,
        subtitle: t3,
        description: t4,
        isPublished: experience.isPublished,
        placeId: experience.placeId
      }
    });
    $[3] = experience.id;
    $[4] = experience.isPublished;
    $[5] = experience.placeId;
    $[6] = experience.title;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}